const IS_DEV = process.env.NODE_ENV === 'development';
const IS_PROD = process.env.NODE_ENV === 'production';

export default {
  provider: 'spotify',
  appBaseUrl: IS_PROD
    ? 'https://fynda-app.firebase.app/'
    : 'http://localhost:3000/',
  socialMediaUrls: {
    facebook: 'https://www.facebook.com',
    instagram: 'https://www.instagram.com',
    twitter: 'https://www.twitter.com',
  },
  picAllowedExt: ['jpg', 'jpeg', 'png'],
  avatarStoragePath:
    'https://firebasestorage.googleapis.com/v0/b/fynda-app.appspot.com/o/avatars%2F',
  avatarStorageFolder: 'avatars',
  nbOfCuratedSongs: 7,
  nbOfRecentActivity: 7,
  nbInDiscoverCarousel: 7,
  defaultListLengthDisplay: 4,
  nbOfTracksToFetch: 20,
  db: {
    userCollection: 'TEST-users',
    songCollection: 'songs',
  },
  genres: {
    ambient: '#A683FC',
    'acid house': '#4557DB',
    acoustic: '#4799FC',
    afrobeat: '#A683FC',
    alternative: '#4557DB',
    'alternative hip hop': '#4799FC',
    'alternative rock': '#A683FC',
    'art pop': '#4557DB',
    'baroque classical': '#4799FC',
    'blues rock': '#A683FC',
  },
};
